import script from "./MySmallCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./MySmallCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./MySmallCheckbox.vue?vue&type=style&index=0&id=872efc08&scoped=true&lang=scss"

import exportComponent from "/home/teamcity-agent/agent3/work/1e41b97f3be6577f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-872efc08"]])

export default __exports__